import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../context/AuthContext';
import {
  BILLING_PATH,
  USERS_PATH,
  getReadOnlyPlanBanner,
  isCompanyAdmin
} from '../utils/planAccess';
import './PlanLimitBanner.css';

const PlanLimitBanner = () => {
  const { user } = useContext(AuthContext);
  const { t } = useTranslation('common');
  const banner = getReadOnlyPlanBanner(user);

  if (!banner) {
    return null;
  }

  const admin = isCompanyAdmin(user);

  const title =
    banner.reason === 'over_user_cap'
      ? t('planBannerOverCapTitle')
      : t('planBannerPastDueTitle');

  const message =
    banner.reason === 'over_user_cap'
      ? t('planBannerOverCapMessage', {
          memberCount: banner.memberCount,
          planId: banner.planId,
          maxUsers: banner.maxUsers,
          usersToRemove: banner.usersToRemove,
          count: banner.usersToRemove
        })
      : t('planBannerPastDueMessage');

  return (
    <div className={`plan-limit-banner plan-limit-banner-${banner.reason}`} role="alert">
      <div className="plan-limit-banner-content">
        <strong>{title}</strong>
        <p>{message}</p>
        {banner.reason === 'over_user_cap' && admin && (
          <p className="plan-limit-banner-actions">
            <Link to={USERS_PATH}>{t('removeUsers')}</Link>
            <span aria-hidden="true"> · </span>
            <Link to={BILLING_PATH}>{t('upgradePlan')}</Link>
          </p>
        )}
        {banner.reason === 'over_user_cap' && !admin && (
          <p className="plan-limit-banner-actions">{t('planBannerOverCapEmployee')}</p>
        )}
        {banner.reason === 'past_due' && admin && (
          <p className="plan-limit-banner-actions">
            <Link to={BILLING_PATH}>{t('updatePaymentMethod')}</Link>
          </p>
        )}
        {banner.reason === 'past_due' && !admin && (
          <p className="plan-limit-banner-actions">{t('planBannerPastDueEmployee')}</p>
        )}
      </div>
    </div>
  );
};

export default PlanLimitBanner;
